import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const REASON_ROW_HEIGHT_REM = 2.5
const VISIBLE_REASONS_COUNT = 6
const REASON_ROW_GAP_REM = 0.5

const REASONS_LIST_MAX_HEIGHT_REM = REASON_ROW_HEIGHT_REM * VISIBLE_REASONS_COUNT + REASON_ROW_GAP_REM * (VISIBLE_REASONS_COUNT - 1)

const useStyles = makeStyles((theme) => ({
	lossReasonsList: {
		maxHeight: `${REASONS_LIST_MAX_HEIGHT_REM}rem`,
		overflowY: "auto"
	},
	fieldLabel: {
		fontSize: "14px",
		fontWeight: 500,
		color: themeColors.colors.system.gray[700],
		margin: 0,
		lineHeight: 1
	},
	responsibleUserSelect: {
		width: "100%"
	},
	responsibleUserSelectInput: {
		display: "flex",
		alignItems: "center"
	},
	responsibleUserPlaceholder: {
		color: themeColors.colors.system.gray[400]
	},
	fieldInput: {
		marginTop: theme.spacing(0.5)
	},
	lossReasonSection: {
		marginTop: theme.spacing(2)
	},
	lossReasonTitle: {
		fontSize: "16px",
		fontWeight: 500,
		color: themeColors.getTextColor(),
		marginBottom: theme.spacing(1)
	},
	lossReasonOption: {
		margin: 0,
		width: "100%",
		borderRadius: "0.5rem",
		padding: theme.spacing(0.5, 1)
	},
	lossReasonOptionSelected: {
		border: `1px solid ${themeColors.colors.error[700]}`,
		backgroundColor: themeColors.colors.error[50]
	},
	lossReasonOptionUnselected: {
		border: `1px solid ${themeColors.colors.system.gray[200]}`
	},
	lossReasonRadio: {
		color: themeColors.colors.system.gray[400],
		"&.Mui-checked": {
			color: themeColors.colors.error[700]
		}
	},
	lossReasonConfigHint: {
		marginTop: theme.spacing(1),
		backgroundColor: themeColors.colors.primary[50],
		borderRadius: "0.5rem",
		padding: theme.spacing(0.75)
	},
	lossReasonConfigLink: {
		cursor: "pointer"
	},
	errorText: {
		color: themeColors.colors.error[600],
		fontSize: "12px",
		marginTop: theme.spacing(0.5)
	},
	concludeButtonWon: {
		height: "40px",
		padding: "0px 8px",
		fontSize: "14px",
		backgroundColor: themeColors.colors.system.green[700],
		"&:hover": {
			backgroundColor: themeColors.colors.system.green[800]
		}
	},
	concludeButtonLost: {
		height: "40px",
		padding: "0px 8px",
		fontSize: "14px",
		backgroundColor: themeColors.colors.system.red[700],
		"&:hover": {
			backgroundColor: themeColors.colors.system.red[800]
		}
	}
}))

export default useStyles
